import api from './api';

const ENDPOINT = 'redemptions';

const RedemptionMapiPayService = {
  trade: (points) => api.post(`${ENDPOINT}/tradeMapipay`, { points })
};

export default RedemptionMapiPayService;
 